import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PageLayout from '../../../components/common/PageLayout';
import ButtonBS from '../../../components/common/ButtonBS';
import DropdownBS from '../../../components/common/DropdownBS';
import { fetchOccupationOptions } from '../../../actions/occupationActions';
import { updateOccupation } from '../../../actions/updateActions';
import { EnterOccupation as i18nStrings } from '../../../middlewares/i18n';
import '../../../styles/EnterOccupation/EnterOccupation.css';

class EnterOccupation extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedPosition: null,
      selectedIndustry: null
    };
    this.handlePositionChange = this.handlePositionChange.bind(this);
    this.handleIndustryChange = this.handleIndustryChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.props.fetchOccupationOptions();
  }

  handlePositionChange(option) {
    this.setState({ selectedPosition: option });
  }

  handleIndustryChange(option) {
    this.setState({ selectedIndustry: option });
  }

  submit() {
    const { selectedPosition, selectedIndustry } = this.state;
    if (selectedPosition && selectedIndustry) {
      this.props.updateOccupation(selectedPosition.value, selectedIndustry.value);
    }
  }

  render() {
    const { positions, industries, i18n } = this.props;
    const { selectedPosition, selectedIndustry } = this.state;
    const lang = i18n.language.current;

    const positionOptions = positions.map(p => ({ value: p.id, label: p.name[lang] })).sort((a, b) => a.label.localeCompare(b.label));
    const industryOptions = industries.map(i => ({ value: i.id, label: i.name[lang] })).sort((a, b) => a.label.localeCompare(b.label));

    const isSubmitDisabled = !selectedPosition || !selectedIndustry;
    const t = i18nStrings[lang];

    return (
      <PageLayout title={t.title}>
        <div className="enter-occupation-container">
          <div className="enter-occupation-dropdown">
            <h6 className="input-title no-margin">{t.industry}</h6>
            <DropdownBS
              className="occupation-dropdown"
              options={industryOptions}
              value={selectedIndustry}
              onChange={this.handleIndustryChange}
              placeholder={t.selectIndustry}
              closeOnSelect={true}
            />
          </div>
          <div className="enter-occupation-dropdown">
            <h6 className="input-title no-margin">{t.position}</h6>
            <DropdownBS
              className="occupation-dropdown"
              options={positionOptions}
              value={selectedPosition}
              onChange={this.handlePositionChange}
              placeholder={t.selectPosition}
              closeOnSelect={true}
            />
          </div>
          <ButtonBS
            className="occupation-submit-button"
            content={t.submit}
            onClick={this.submit}
            disabled={isSubmitDisabled}
          />
        </div>
      </PageLayout>
    );
  }
}

function mapStateToProps(state) {
  return {
    positions: state.occupation.positions,
    industries: state.occupation.industries,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchOccupationOptions,
      updateOccupation
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EnterOccupation);
